import { FC } from "react";
import { ClientProps } from "../../../hooks/useClientData";
import { WinnerCard } from "./WinnerCard";
import { useTimer } from "../../../hooks/useCountDown";
import { MapsList } from "../../../consts/MapsLIst";
import { TimerComp } from "./TimerComp";
import { ReactComponent as ElgigantenMap } from "../assets/elgiganten/Monza_ELGIGANTEN.svg";
import { brand } from "@/brandVariables/getBandVariables";
import brick_track from "../assets/lego_f1/brick_track_right.png";

export const Racing_meta: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const MapRender = MapsList["grand oak"];

  const { time } = useTimer(clientData.challenge.data?.endDate || undefined);

  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";

  const mapToRender = () => {
    if (brand.brand === "logitech" || brand.brand === "legof1") {
      const Map = brand.metaInfo.map;
      return <Map />;
    }

    if (brand.client === "elgiganten-9u2oj") {
      return <ElgigantenMap />;
    } else {
      return <MapRender />;
    }
  };

  if (brand.client === "LEGOF1") {
    return (
      <div className="meta">
        <img src={brick_track} alt="" />
      </div>
    );
  }

  return (
    <div className="meta">
      <div className="meta__timer">
        <TimerComp time={time} />
      </div>

      <div className="meta__map">
        <div>
          <p>Track:</p>
          <h2 className={isElgiganten}>{brand.metaInfo.trackName}</h2>
        </div>
        <div>{mapToRender()}</div>
      </div>

      {clientData.winners.data.length !== 0 && (
        <div className={`meta__winner`}>
          <div className={`winner__banner ${isElgiganten}`}>
            <p>previous winner</p>
          </div>
          <WinnerCard clientData={clientData} hasBanner={false} />
        </div>
      )}
    </div>
  );
};
